import _sfc_main$1 from "./code_editor_opening_tag.vue.js";
import _sfc_main$2 from "./code_editor_closing_tag.vue.js";
import { createBlock, createCommentVNode, createElementBlock, createElementVNode, createVNode, openBlock, renderSlot, withCtx } from "vue";
//#region src/components/code_editor/code_editor_element.vue
var _hoisted_1 = { key: 0 };
var _hoisted_2 = { class: "dtc-code-editor__margin" };
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorElement" }, {
	props: {
		tagName: {
			type: String,
			required: true
		},
		selfClosing: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", null, [
				createVNode(_sfc_main$1, { name: __props.tagName }, {
					default: withCtx(() => [renderSlot(_ctx.$slots, "opening"), __props.selfClosing ? (openBlock(), createElementBlock("span", _hoisted_1, " /")) : createCommentVNode("", true)]),
					_: 3
				}, 8, ["name"]),
				createElementVNode("div", _hoisted_2, [renderSlot(_ctx.$slots, "default")]),
				!__props.selfClosing ? (openBlock(), createBlock(_sfc_main$2, {
					key: 0,
					name: __props.tagName
				}, null, 8, ["name"])) : createCommentVNode("", true)
			]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_element.vue.js.map